"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = void 0;
var tslib_1 = require("tslib");
var http_client_1 = require("@wix/http-client");
var GraphQLClientRequestError_1 = tslib_1.__importDefault(require("./GraphQLClientRequestError"));
var httpClient = new http_client_1.HttpClient();
exports.httpClient = httpClient;
var DEFAULT_CONFIG = {
    endpoint: '/',
};
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(config) {
        this.init(config);
    }
    GraphQLClient.prototype.init = function (config) {
        this._config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
    };
    GraphQLClient.prototype.request = function (query, variables) {
        function handleError(error, response) {
            var errorResult;
            if (!response) {
                errorResult = { error: error && error.message };
            }
            else if (typeof response.data === 'string') {
                errorResult = { error: response.data };
            }
            else {
                errorResult = response.data;
            }
            throw new GraphQLClientRequestError_1.default({ query: query, variables: variables }, tslib_1.__assign(tslib_1.__assign({}, errorResult), { status: response && response.status }));
        }
        return httpClient.post(this._config.endpoint, { query: query, variables: variables }).then(function (response) {
            var _a = response.data, errors = _a.errors, data = _a.data;
            if (!errors && data) {
                return data;
            }
            return handleError(null, response);
        }, function (error) { return handleError(error, error.response); });
    };
    return GraphQLClient;
}());
exports.default = GraphQLClient;
//# sourceMappingURL=GraphQLClient.js.map